import * as React from 'react';

export const PRIMARY_TEXT = '#1E252F';

export const cardStyle: React.CSSProperties = {
  backgroundColor: '#FFFFFF',
  borderRadius: '16px',
  border: '1px solid rgba(0, 0, 0, 0.1)',
  padding: '16px',
  flex: '1 1 0',
  minWidth: 0,
  display: 'flex',
  flexDirection: 'column',
  gap: '8px',
};

export const cardRowStyle: React.CSSProperties = {
  gap: '16px',
  alignItems: 'stretch',
  marginTop: '16px',
};

export const cardTitleStyle: React.CSSProperties = {
  fontSize: '16px',
  lineHeight: '24px',
  color: PRIMARY_TEXT,
};

export const cardSubtitleStyle: React.CSSProperties = {
  fontSize: '12px',
  lineHeight: '18px',
  color: PRIMARY_TEXT,
};

export const platformSelectorWrapperStyle: React.CSSProperties = {
  border: '1px solid #BDC4D5',
  borderRadius: '6px',
  backgroundColor: '#FBFBFB',
  cursor: 'pointer',
  padding: '1px 8px 3px',
};
